module.exports = __webpack_public_path__ + "img/level_six_hover.2ae15cd5.png";